
import React from 'react'
import { User } from '../types/auth'



interface UserInfoProps {
  user: User | null
}

export default function UserInfo({ user }: UserInfoProps) {
  return (
    <div className="p-4 border-t border-gray-700/50">
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <div className="w-10 h-10 bg-gradient-to-br from-brand-primary to-brand-accent-600 rounded-full flex items-center justify-center shadow-monumenta">
            <span className="text-sm font-bold text-brand-dark font-display">
              {user?.name.charAt(0)}
            </span>
          </div>
        </div>
        <div className="ml-3 flex-1 min-w-0">
          <p className="text-sm font-medium text-white truncate font-display">
            {user?.name}
          </p>
          <p className="text-xs text-brand-gray-light truncate font-body">
            {user?.employee?.employment?.role?.name || user?.role}
          </p>
        </div>
      </div>
    </div>
  )
}